<template>
  <nav class="about-nav">
    <div class="pc-container about-inner">
      <button
        v-for="item in tabs"
        :key="item"
        :class="{ active: item === '公司新闻' }"
        @click="handleClick(item)"
      >
        {{ item }}
      </button>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'PcNewsNav',
    data() {
      return {
        tabs: ['公司新闻']
      }
    },
    methods: {
      handleClick(item) {
        if (item === '公司新闻') {
          this.$router.push('/pc/news')
        }
      }
    }
  }
</script>

<style scoped>
  .about-nav {
    height: 54px;
    background: #f6f6f6;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #e5e7eb;
  }

  .about-inner {
    height: 54px;
    display: flex;
    align-items: center;
    gap: 22px;
  }

  .about-inner button {
    position: relative;
    height: 54px;
    padding: 0 10px;
    border: 0;
    background: transparent;
    color: #344054;
    font-size: 14px;
    cursor: pointer;
  }

  .about-inner button:first-child {
    color: #111827;
    font-weight: 700;
  }

  .about-inner button:first-child:after {
    content: "";
    position: absolute;
    right: -12px;
    top: 18px;
    width: 1px;
    height: 18px;
    background: #64748b;
  }

  .about-inner .active {
    color: #008bea;
  }

  .about-inner .active:before {
    content: "";
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 0;
    height: 2px;
    background: #85ddff;
  }
</style>
